module.exports = __webpack_public_path__ + "static/media/PredictingAmznReviews.9bfd2e5a.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/PredictingAmznReviews.JPG
// module id = 50
// module chunks = 0